/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import { Select, TextInput } from '@mantine/core';
import AppFlexbox from '../../common/AppFlexbox';
import AppStack from '../../common/AppStack';
import AppText from '../../common/AppText';
import { isValidCanadianPostalCode } from '../../../helpers/shop/webstoreHelper';
import {
  CANADA_PROVINCE_LIST_OPTIONS,
  USA_STATE_LIST_OPTIONS
} from '../../../config/locationConstants';

const CheckoutOrderAddressForm = ({
  loading,
  shippingController,
  disabled
}) => {
  const {
    debouncedState,
    shippingAddress,
    shippingLoading,
    onChangeShippingAddress
  } = shippingController;

  const orderSummaryLoading = loading || shippingLoading;

  return (
    <>
      <AppText style={{ fontSize: 18, fontWeight: 700 }}>Delivery</AppText>

      <AppStack style={{ gap: 8 }}>
        <AppStack style={{ gap: 8 }}>
          <Select
            clearable
            data={[
              {
                label: 'Canada',
                value: 'CA'
              },
              {
                label: 'United States',
                value: 'US'
              }
            ]}
            disabled
            label="Country"
            onChange={(v) => {
              if (!!v && v !== shippingAddress?.country) {
                onChangeShippingAddress({
                  country: v,
                  state: (v === 'US'
                    ? USA_STATE_LIST_OPTIONS
                    : CANADA_PROVINCE_LIST_OPTIONS
                  ).find((s) => s.abbr === shippingAddress?.state)
                });
              }
            }}
            required
            searchable
            styles={{
              input: {
                minHeight: 0,
                height: 30,
                fontSize: 14
              }
            }}
            value={shippingAddress?.country || ''}
          />
          <AppFlexbox style={{ gap: 8 }}>
            <TextInput
              disabled={disabled}
              label="First name"
              onChange={(e) => {
                onChangeShippingAddress({ firstName: e.currentTarget.value });
              }}
              required
              style={{ flex: 1 }}
              styles={{
                input: {
                  minHeight: 0,
                  height: 30,
                  fontSize: 14
                }
              }}
              value={shippingAddress?.firstName || ''}
            />

            <TextInput
              disabled={disabled}
              label="Last name"
              onChange={(e) => {
                onChangeShippingAddress({ lastName: e.currentTarget.value });
              }}
              required
              style={{ flex: 1 }}
              styles={{
                input: {
                  minHeight: 0,
                  height: 30,
                  fontSize: 14
                }
              }}
              value={shippingAddress?.lastName || ''}
            />
          </AppFlexbox>

          <TextInput
            disabled={disabled}
            label="Address"
            onChange={(e) => {
              onChangeShippingAddress({ address1: e.currentTarget.value });
            }}
            required
            style={{ flex: 1 }}
            styles={{
              input: {
                minHeight: 0,
                height: 30,
                fontSize: 14
              }
            }}
            value={shippingAddress?.address1 || ''}
          />

          <AppFlexbox style={{ gap: 8 }}>
            <TextInput
              disabled={disabled}
              inputSize="xs"
              label="City"
              onChange={(e) => {
                onChangeShippingAddress({ city: e.currentTarget.value });
              }}
              required
              style={{ flex: 1 }}
              styles={{
                input: {
                  minHeight: 0,
                  height: 30,
                  fontSize: 14
                }
              }}
              value={shippingAddress?.city || ''}
            />
            <Select
              clearable
              data={
                shippingAddress?.country === 'US'
                  ? USA_STATE_LIST_OPTIONS.map((s) => ({
                      label: s.label,
                      value: s.abbr
                    }))
                  : CANADA_PROVINCE_LIST_OPTIONS.map((p) => ({
                      label: p.label,
                      value: p.abbr
                    }))
              }
              disabled={disabled}
              inputSize="xs"
              label="Province"
              onChange={(v) => {
                if (v && v !== shippingAddress?.state) {
                  onChangeShippingAddress({ state: v });
                }
              }}
              required
              searchable
              style={{ flex: 1 }}
              styles={{
                input: {
                  minHeight: 0,
                  height: 30,
                  fontSize: 14
                }
              }}
              value={shippingAddress?.state || null}
            />
          </AppFlexbox>

          <TextInput
            disabled={disabled}
            error={
              !orderSummaryLoading &&
              shippingAddress?.postalCode &&
              (!debouncedState ||
                shippingAddress?.postalCode === debouncedState?.postalCode) &&
              !isValidCanadianPostalCode(shippingAddress?.postalCode)
                ? 'Postal code is invalid'
                : null
            }
            label="Postal code"
            onChange={(e) => {
              onChangeShippingAddress({ postalCode: e.currentTarget.value });
            }}
            required
            style={{ flex: 1 }}
            styles={{
              input: {
                minHeight: 0,
                height: 30,
                fontSize: 14
              }
            }}
            value={shippingAddress?.postalCode || ''}
          />
        </AppStack>
      </AppStack>
    </>
  );
};

CheckoutOrderAddressForm.propTypes = {
  shippingController: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  loading: PropTypes.bool
};

export default CheckoutOrderAddressForm;
